"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var FileInput_1 = require("../FileInput");
var RequiredMark_1 = require("../RequiredMark");
var styles = require("./index.module.css");
var LabeledFileInput = /** @class */ (function (_super) {
    __extends(LabeledFileInput, _super);
    function LabeledFileInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabeledFileInput.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style, labelClassName = _a.labelClassName, labelStyle = _a.labelStyle, inputClassName = _a.inputClassName, inputStyle = _a.inputStyle, label = _a.label, required = _a.required, inputProps = __rest(_a, ["className", "style", "labelClassName", "labelStyle", "inputClassName", "inputStyle", "label", "required"]);
        return (React.createElement("div", { className: classnames_1.default(styles.labeledFileInput, className), style: style },
            React.createElement("span", { className: classnames_1.default(styles.label, labelClassName), style: labelStyle },
                label,
                required && React.createElement(RequiredMark_1.default, null)),
            React.createElement(FileInput_1.default, __assign({ className: inputClassName, style: inputStyle }, inputProps))));
    };
    return LabeledFileInput;
}(React.Component));
exports.default = LabeledFileInput;
